/*
 *
 * Disputes constants
 *
 */

import moment from 'moment';
import { DEFAULT_CURRENT_PAGE, DEFAULT_LIMIT } from '../../utils/constants';

export const BASE_ACTION_CONSTANT = 'app/Disputes';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const GET_COUNT_AND_SUM = `${BASE_ACTION_CONSTANT}/GET_COUNT_AND_SUM`;

export const SAVE_COUNT_AND_SUM = `${BASE_ACTION_CONSTANT}/SAVE_COUNT_AND_SUM`;

export const GET_TABLE_DATA = `${BASE_ACTION_CONSTANT}/GET_TABLE_DATA`;

export const SAVE_DATA = `${BASE_ACTION_CONSTANT}/SAVE_DATA`;

export const ACCEPT_DISPUTE = `${BASE_ACTION_CONSTANT}/ACCEPT_DISPUTE`;

export const UPLOAD_DOCS = `${BASE_ACTION_CONSTANT}/UPLOAD_DOCS`;

export const GET_DISPUTE_DOCS = `${BASE_ACTION_CONSTANT}/GET_DISPUTE_DOCS`;

export const SAVE_DISPUTE_DOCS = `${BASE_ACTION_CONSTANT}/SAVE_DISPUTE_DOCS`;

export const GET_UPLOADED_DISPUTE_DOCS = `${BASE_ACTION_CONSTANT}/GET_UPLOADED_DISPUTE_DOCS`;

export const SAVE_UPLOADED_DISPUTE_DOCS = `${BASE_ACTION_CONSTANT}/SAVE_UPLOADED_DISPUTE_DOCS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const EXPORT_TO_CSV = `${BASE_ACTION_CONSTANT}/EXPORT_TO_CSV`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const REMOVE_DATE_FILTER = `${BASE_ACTION_CONSTANT}/REMOVE_DATE_FILTER`;

export const RESET_REDUCER = `${BASE_ACTION_CONSTANT}/RESET_REDUCER`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_RISKSHIELD_ACTIVATE_STATUS = `${BASE_ACTION_CONSTANT}/GET_RISKSHIELD_ACTIVATE_STATUS`;

export const SET_RISKSHIELD_ACTIVATE_STATUS = `${BASE_ACTION_CONSTANT}/SET_RISKSHIELD_ACTIVATE_STATUS`;

export const GET_DISPUTE_DETAILS = `${BASE_ACTION_CONSTANT}/GET_DISPUTE_DETAILS`;

export const SET_DISPUTE_DETAILS = `${BASE_ACTION_CONSTANT}/SET_DISPUTE_DETAILS`;

export const GET_FIRST_PG_TRANSACTION_DATE = `${BASE_ACTION_CONSTANT}/GET_FIRST_PG_TRANSACTION_DATE`;

export const SET_FIRST_PG_TRANSACTION_DATE = `${BASE_ACTION_CONSTANT}/SET_FIRST_PG_TRANSACTION_DATE`;

export const GET_COUNT_AND_SUM_URL = {
  url: '/pg/disputes/summary',
  method: 'GET',
};

export const GET_TABLE_DATA_URL = {
  url: '/pg/disputes/searchAll',
  method: 'GET',
};

export const ACCEPT_DISPUTE_URL = {
  url: '/pg/disputes/accept',
  method: 'PUT',
};

export const UPLOAD_DOCS_URL = {
  url: '/pg/disputes/documents/caseId/$disputeId$',
  method: 'POST',
};

export const GET_DISPUTE_DOCS_URL = {
  url: '/pg/disputes/documents-to-contest/caseId/$disputeId$',
  method: 'GET',
};

export const GET_UPLOADED_DISPUTE_DOCS_URL = {
  url: '/pg/disputes/documents/caseId/$disputeId$',
  method: 'GET',
};

export const GET_RISKSHIELD_ACTIVE_STATUS_URL = {
  url: '/merchant/v1/risk-platform/product/PG/status',
  method: 'GET',
};

export const GET_DISPUTE_DETAILS_URL = {
  url: '/merchant/v1/risk-platform/dexter/aggregatedDataPG',
  method: 'POST',
};

export const GET_FIRST_PG_TRANSACTION_DATE_URL = {
  url: '/merchant/v1/risk-platform/merchant/metadata',
  method: 'GET',
};

export const PG_RISK_DISP_AGG_FILTER = 'PG_RISK_DISP_AGG_FILTER';

export const MIN_DISPUTES_WORTH = 5000;

export const MIN_DISPUTES_LOST_AMOUNT = 1000;

export const ACTION_REQUIRED_CARD_DETAILS = [
  {
    key: 'DUE_TODAY',
    displayName: 'Due Today',
    remark: 'Urgent',
    stateColor: '#CB2C2C',
    customIcon: 'URGENT',
    backgroundColor: '#F7DFDF',
  },
  {
    key: 'DUE_TOMORROW',
    displayName: 'Due Tomorrow',
    remark: 'Critical',
    stateColor: '#D68309',
    customIcon: 'URGENT',
    backgroundColor: '#FBF3E6',
  },
  {
    key: 'MORE_DOCS_REQUIRED',
    displayName: 'Insufficient Evidence',
    remark: '',
    stateColor: '#F17100',
    customIcon: 'INSUFFICIENT_EVIDENCE',
    backGroundColor: '',
  },
];

export const CLOSED_DISPUTES_DETAILS = [
  {
    key: 'DISPUTES_WON',
    displayName: 'Total Disputes Won',
    stateColor: '#00A331',
    amountDisplay: 'Amount Saved',
  },
  {
    key: 'DISPUTES_LOST',
    displayName: 'Total Disputes Lost',
    stateColor: '#CB2C2C',
    amountDisplay: 'Amount Refunded',
  },
  {
    key: 'DISPUTES_ACCEPTED',
    displayName: 'Total Disputes Accepted',
    stateColor: '#D68309',
    amountDisplay: 'Amount Refunded',
  },
];

export const HEADINGS = {
  'Action Required': [
    {
      key: 'updatedOn',
      displayName: 'Updated On',
    },
    {
      key: 'createdOn',
      displayName: 'Created On',
      align: 'left',
    },
    {
      key: 'disputeId',
      displayName: 'Dispute ID',
    },
    {
      key: 'orderId',
      displayName: 'Order ID',
    },
    {
      key: 'transactionId',
      displayName: 'Transaction ID',
    },
    {
      key: 'type',
      displayName: 'Type',
    },
    {
      key: 'disputeAmt',
      displayName: 'Dispute Amt.',
      align: 'right',
    },
    {
      key: 'respondBy',
      displayName: 'Respond By',
      align: 'right',
    },
    {
      key: 'action',
      displayName: 'Action',
      align: 'center',
    },
  ],
  'Under Review': [
    {
      key: 'updatedOn',
      displayName: 'Updated On',
    },
    {
      key: 'createdOn',
      displayName: 'Created On',
    },
    {
      key: 'disputeId',
      displayName: 'Dispute ID',
    },
    {
      key: 'orderId',
      displayName: 'Order ID',
    },
    {
      key: 'transactionId',
      displayName: 'Transaction ID',
    },
    {
      key: 'type',
      displayName: 'Type',
    },
    {
      key: 'disputeAmt',
      displayName: 'Dispute Amt.',
      align: 'right',
    },
    {
      key: 'respondBy',
      displayName: 'Respond By',
      align: 'right',
    },
    {
      key: 'underReviewIcon',
      displayName: '',
      align: 'right',
    },
  ],
  Closed: [
    {
      key: 'updatedOn',
      displayName: 'Updated On',
    },
    {
      key: 'createdOn',
      displayName: 'Created On',
    },
    {
      key: 'disputeId',
      displayName: 'Dispute ID',
    },
    {
      key: 'orderId',
      displayName: 'Order ID',
    },
    {
      key: 'transactionId',
      displayName: 'Transaction ID',
    },
    {
      key: 'type',
      displayName: 'Type',
    },
    {
      key: 'disputeAmt',
      displayName: 'Dispute Amt.',
      align: 'right',
    },
    {
      key: 'resolvedOn',
      displayName: 'Resolved On',
      align: 'right',
    },
    {
      key: 'result',
      displayName: 'Result',
      align: 'center',
    },
  ],
  'All Disputes': [
    {
      key: 'updatedOn',
      displayName: 'Updated On',
    },
    {
      key: 'createdOn',
      displayName: 'Created On',
    },
    {
      key: 'disputeId',
      displayName: 'Dispute ID',
    },
    {
      key: 'orderId',
      displayName: 'Order ID',
    },
    {
      key: 'transactionId',
      displayName: 'Transaction ID',
    },
    {
      key: 'type',
      displayName: 'Type',
    },
    {
      key: 'disputeAmt',
      displayName: 'Dispute Amt.',
      align: 'right',
    },
    {
      key: 'respondBy',
      displayName: 'Respond By',
      align: 'right',
    },
    {
      key: 'status',
      displayName: 'Status',
      align: 'center',
    },
  ],
};

export const GET_COUNT_AND_SUM_PAYLOAD = [
  'DUE_TODAY',
  'DUE_TOMORROW',
  'MORE_DOCS_REQUIRED',
  'NEW_CASES_ADDED_TODAY',
  'ACTION_REQUIRED',
  'DISPUTES_WON',
  'DISPUTES_LOST',
  'DISPUTES_ACCEPTED',
];

export const TRANSACTIONS_DATA_MAPPER = {
  updatedOn: 'Updated On',
  addedOn: 'Added On',
  orderId: 'Order ID',
  cfTxnId: 'Transaction ID',
  caseId: 'Dispute ID',
  type: 'Type',
  reason: 'Dispute Reason',
  disputeAmount: 'Dispute Amount',
  resolveBy: 'Respond By',
  status: 'Status',
  isResolved: 'Is Resolved',
  resolvedOn: 'Resolved On',
  transactionCurrency: 'Transaction Currency',
  amount: 'Transaction Amount',
  customerPhone: 'Customer phone',
  txTime: 'Transaction Time',
};

export const DEFAULT_DISPUTES_STATE = {
  filters: {
    appliedFilters: {
      startDate: moment()
        .subtract(6, 'months')
        .startOf('day')
        .format('YYYY-MM-DD 00:00:00'),
      endDate: moment()
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss'),
    },
    dateFilters: {
      displayText: 'Last 6 Months',
      range: [
        moment()
          .subtract(6, 'months')
          .startOf('day')
          .toDate(),
        moment()
          .endOf('day')
          .toDate(),
      ],
    },
    pageSize: DEFAULT_LIMIT,
    pageNo: DEFAULT_CURRENT_PAGE,
  },
  data: [],
  totalCount: 0,
  totalPages: 0,
  hasPrev: false,
  hasNext: false,
  currentPageRowData: [],
  filtersForDisplay: [],
};

export const RADIO_DATA = {
  radioOptions: [
    {
      label: 'Accept Dispute',
      name: 'selected',
      value: 'accept',
    },
    {
      label: 'Contest Dispute and Submit Evidence',
      name: 'selected',
      value: 'contest',
    },
  ],
};

export const MERCHANT_WON = 'MERCHANT_WON';

export const MERCHANT_LOST = 'MERCHANT_LOST';

export const MERCHANT_ACCEPTED = 'MERCHANT_ACCEPTED';

export const NEW = 'NEW';

export const NEED_MORE_DOCS = 'NEED_MORE_DOCS';

export const DOC_RECEIVED = 'DOC_RECEIVED';

export const CONTESTED = 'CONTESTED';

export const ALL_DISPUTES_STATUS_MAPPING = {
  WON: [MERCHANT_WON],
  LOST: [MERCHANT_LOST],
  ACCEPTED: [MERCHANT_ACCEPTED],
  UNDER_REVIEW: [DOC_RECEIVED, CONTESTED],
  TAKE_ACTION: [NEW],
  UPLOAD_EVIDENCE: [NEED_MORE_DOCS],
};

export const ALL_DISPUTES = 'All Disputes';

export const COMMENT = 'COMMENT';

export const TAKE_ACTION = 'Take Action';

export const UNDER_REVIEW = 'Under Review';

export const UPLOAD_MORE_EVIDENCE = 'Upload More Evidence';

export const ACTION_REQUIRED = 'Action Required';

export const CLOSED = 'Closed';

export const DISPUTES_ACCEPTED_SUCCESS = 'Dispute Accepted Success';

export const EVIDENCE_SUBMITTED = 'Evidence Submitted';

export const DISPUTE_CONTESTED_SUCCESS = 'Dispute Contested Success';

export const DISPUTES_DATE_FORMAT = 'DD MMM YYYY';

export const MAX_FILE_SIZE = 20971520;

export const DUE_TODAY = 'DUE_TODAY';

export const DUE_TOMORROW = 'DUE_TOMORROW';

export const DISPUTES_LOST = 'DISPUTES_LOST';

export const DISPUTES_ACCEPTED = 'DISPUTES_ACCEPTED';

export const DISPUTES_WON = 'DISPUTES_WON';

export const MORE_DOCS_REQUIRED = 'MORE_DOCS_REQUIRED';

export const DISPUTES_TAB = [
  ACTION_REQUIRED,
  UNDER_REVIEW,
  CLOSED,
  ALL_DISPUTES,
];

export const FILE_NAME_REGEX = /^([0-9]|[A-Z]|[a-z]|[!\\-_.*'\\(\\)])+$/;

export const SUPPORTED_FILE_TYPES = ['jpeg', 'jpg', 'png', 'pdf'];

export const RISK_SHIELD_MODAL = 'RISK_SHIELD_MODAL';

export const HEADERS_KEYS = {
  UPDATED_ON: 'updatedOn',
  CREATED_ON: 'createdOn',
  RESPOND_BY: 'respondBy',
};
